// Components==============
import React, { createContext, useState } from 'react';
import { contactTextValues } from './contactTextValues';
// =========================

export const GlobalContext = createContext();

// All values within this context will be persisted on Route change

export default function GlobalContextWrapper({ children }) {
    const [isDashboard, setIsDashboard] = useState(false);
    const [contactText, setContactText] = useState(contactTextValues.contact);

    return (
        <GlobalContext.Provider
            value={{
                isDashboard,
                setIsDashboard,
                contactText,
                setContactText,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
}
